import {load} from '@shopify/theme-sections';
import '../sections/article';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
